import { NotificationInstance, NotificationInstanceDB, groupNotificationsByTypeAndUid } from 'firebaseConfig/notificationsManger'
import * as constants from 'actions/constants'
import { create } from 'domain'

export interface MainReducer {
  lastPostsRefresh: number, //DATE GET TIME
  lastHomeRefresh: number,
  lastGeneralRefresh: number,
  isLoading: boolean,
  goToPage: string,
  notifications: NotificationInstance[],
  notificationsObjects: NotificationInstanceDB[],
  debugMode: boolean,
  isForeground: boolean,
}
const defaultState: MainReducer = {
  lastPostsRefresh: 0,
  lastHomeRefresh: 0,
  lastGeneralRefresh: Date.now(),
  isLoading: false,
  goToPage: '',
  notifications: [],
  notificationsObjects: [],
  debugMode: false,
  isForeground: false
}

export default function Main(state = defaultState, action: any) {
  switch (action.type) {

    case constants.TOGGLE_DEBUG:
      return Object.assign({}, state, { debugMode: !state.debugMode })

    case constants.SET_LAST_HOME:
      return Object.assign({}, state, { lastHomeRefresh: action.lastHomeRefresh })

    case constants.SET_LAST_POSTS:
      return Object.assign({}, state, { lastPostsRefresh: action.lastPostsRefresh })

    case constants.SET_IS_FOREGROUND:
      return Object.assign({}, state, { isForeground: action.isForeground })

    case constants.GO_TO_PAGE:
      return Object.assign({}, state, { goToPage: action.page })

    case constants.RESET_GO_TO_PAGE:
      return Object.assign({}, state, { goToPage: '' })

    case constants.RESET_LOADING:
      return Object.assign({}, state, { isLoading: false })

    case constants.SET_LOADING:
      return Object.assign({}, state, { isLoading: action.state })

    case constants.SET_LAST_GENERAL_REFRESH:
      return Object.assign({}, state, { lastGeneralRefresh: action.lastGeneralRefresh })

    case constants.ADD_NOTIFICATIONS_TO_REDUCER:
      const n = action.notifications?.map((n: any) => {
        return {
          uid: n.uid ?? n.Uid,
          createdAt: n.createdAt ?? n.CreatedAt,
          text: n.text ?? n.Text,
          entryId: n.entryId ?? n.EntryId,
          type: n.type ?? n.Type,
        }
      })
      
      const notifications = groupNotificationsByTypeAndUid(n)
      
      return Object.assign({}, state, { notifications: notifications, notificationsObjects: action.notifications })

    case constants.LOGOUT_RESPONSE:
      return defaultState

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      if (action?.type.includes('_TRY'))
        return Object.assign({}, state, { isLoading: true })
      if (action?.type.includes('_RESPONSE'))
        return Object.assign({}, state, { isLoading: false })
      if (action?.type.includes('_ERROR'))
        return Object.assign({}, state, { isLoading: false })
      return state
  }
}
